import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email }, { withCredentials: true });
    } catch {
      // always show success to prevent email enumeration
    }
    setSent(true);
    setLoading(false);
  };

  return (
    <div data-testid="page-forgot-password">
      <section className="py-20 px-6">
        <div className="max-w-sm mx-auto">
          <div className="text-center mb-8">
            <p className="font-serif text-xl text-[#1A1A1A] mb-2">Reset Password</p>
            <p className="text-sm text-[#6B6B6B]">Enter your email to receive a password reset link.</p>
          </div>

          {sent ? (
            <div className="text-center py-6" data-testid="forgot-password-success">
              <p className="text-sm text-[#6B6B6B] mb-4">If an account with that email exists, a reset link has been sent.</p>
              <Link to="/login" className="text-sm text-[#1A1A1A] underline">Return to login</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
              <div>
                <label className="text-xs uppercase tracking-[0.15em] text-[#999] block mb-1">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  className="w-full border border-[#E8E4DC] rounded px-4 py-2.5 text-sm bg-white focus:outline-none focus:border-[#1A1A1A]"
                  data-testid="forgot-email"
                />
              </div>
              <button type="submit" disabled={loading} className="w-full py-3 bg-[#1A1A1A] text-white text-sm rounded hover:bg-[#333] transition-colors disabled:opacity-50" data-testid="forgot-submit">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}

          <div className="mt-8 text-center">
            <Link to="/login" className="text-sm text-[#6B6B6B] hover:text-[#1A1A1A]">&larr; Back to login</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
